import React,{useState} from 'react';
import { useTranslation } from 'react-i18next';
import {
    ScrollToTop,
    Form,
    Container,
    FormSubmit,
    FormFooter,
    FormHeader,
    Notice,
    FormNext,ScrollIntoView,
    FormBack,
    Helmet
} from "@careers-wales/react-components";
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import DecisionProgress from "../../../components/DecisionProgress";
import {route} from "../../../routes";
import StagedQuestion from "../../../components/StagedQuestion";
import Question from "../../../components/Question";
import AnalyticsEvent from "../../../components/AnalyticsEvent";

function QuizView(props) {
    // Hooks.
    const { t} = useTranslation();
    const [validationError,setValidationError] = useState(false);

    return (
        <Container>
            <Helmet>
                <title>{props.question.pageTitle}</title>
            </Helmet>
            <BreadcrumbsItem to={ route('quiz') }>
                {props.question.pageTitle}
            </BreadcrumbsItem>

            {(props.currentStage === 1) && (props.answers.length === 1) && <AnalyticsEvent event={"decision_making_quiz_started"} />}

            <Form className={"form--no-background form--no-padding form--multi-step"}>
                <ScrollToTop trigger={props.currentStage}/>
                <h1>      {t('view.landing.title')}</h1>
                <DecisionProgress stage={props.currentStage} questions={props.questions} setCurrentStage={props.setCurrentStage}/>
                <FormHeader>
                    {props.currentStage > 0 &&
                        <FormBack
                            className={['button--secondary']}
                            onPress={(event) => {

                                props.setCurrentStage(props.currentStage - 1);
                            }}
                        />}
                </FormHeader>


                {validationError && <div>
                    <ScrollIntoView/>
                    <Notice type={"warning-alert"}>
                        {t('view.stages.common.validationError')}
                    </Notice></div>}

                <div className={"bg-panel"}>
                    <h2 className={"gel-xs-mt-0"}> {props.question.pageTitle}</h2>
            

                    {props.question.type === "initial" ? <Question {...props} setValidationError={setValidationError}/> : <StagedQuestion {...props}  setValidationError={setValidationError}/>}
                </div>
                <FormFooter>

                    {props.currentStage > 0 &&
                    <FormBack
                        ariaLabel={t('styleguide:link_to_previous')}
                        title={t('styleguide:link_to_previous')}
                        onPress={(event) => {

                            props.setCurrentStage(props.currentStage - 1);
                        }}
                    />}



                    {props.currentStage + 1 === props.questions.questions.length ?
                        <FormSubmit
                            isDisabled={!props.answers[props.currentStage] || (props.answers[props.currentStage] && (props.answers[props.currentStage].length !== 2))}
                            onPress={(event) => {
                                window.dataLayer && window.dataLayer.push({event: "decision_making_quiz_complete"});
                                props.submit();
                            }}
                        ></FormSubmit>

                        :

                        <FormNext
                            answers={props.answers}
                            key={props.currentStage}
                            title={t('styleguide:link_to_next')}
                            ariaLabel={t('styleguide:link_to_next')}
                            isDisabled={!props.answers[props.currentStage] || (props.answers[props.currentStage] && (props.answers[props.currentStage].length !== 2))}
                            onPress={(event) => {
                                setValidationError(null);
                                props.setCurrentStage(props.currentStage + 1);
                            }}
                        />

                    }

                </FormFooter>
            </Form>
        </Container>
    )
}
export default QuizView;
